export const regionsAndSitesData = [
  {
    "fullName": "Brazil",
    "abbreviation": "BR",
    "regionId": "29",
    "siteId": "132",
    "dataDeploymentArea": "GLOBAL",
    "availableForSemiSellers": "",
    "availableForLocalSellers": "coming soon"
  },
  {
    "fullName": "Ireland",
    "abbreviation": "IE",
    "regionId": "96",
    "siteId": "116",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "coming soon"
  },
  {
    "fullName": "Switzerland",
    "abbreviation": "CH",
    "regionId": "192",
    "siteId": "114",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "coming soon"
  },
  {
    "fullName": "Estonia",
    "abbreviation": "EE",
    "regionId": "64",
    "siteId": "149",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "coming soon"
  },
  {
    "fullName": "United Arab Emirates",
    "abbreviation": "AE",
    "regionId": "209",
    "siteId": "122",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "coming soon"
  },
  {
    "fullName": "Latvia",
    "abbreviation": "LV",
    "regionId": "108",
    "siteId": "150",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "coming soon"
  },
  {
    "fullName": "Jordan",
    "abbreviation": "JO",
    "regionId": "101",
    "siteId": "131",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "coming soon",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Mauritius",
    "abbreviation": "MU",
    "regionId": "126",
    "siteId": "170",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "coming soon",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "North Macedonia",
    "abbreviation": "MK",
    "regionId": "116",
    "siteId": "160",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "coming soon",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Montenegro",
    "abbreviation": "ME",
    "regionId": "134",
    "siteId": "155",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "coming soon",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Brunei Darussalam",
    "abbreviation": "BN",
    "regionId": "31",
    "siteId": "188",
    "dataDeploymentArea": "GLOBAL",
    "availableForSemiSellers": "coming soon",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Iceland",
    "abbreviation": "IS",
    "regionId": "91",
    "siteId": "156",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "coming soon",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Panama",
    "abbreviation": "PA",
    "regionId": "156",
    "siteId": "176",
    "dataDeploymentArea": "GLOBAL",
    "availableForSemiSellers": "coming soon",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Sri Lanka",
    "abbreviation": "LK",
    "regionId": "187",
    "siteId": "185",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "coming soon",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Kyrgyzstan",
    "abbreviation": "KG",
    "regionId": "106",
    "siteId": "194",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "coming soon",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Türkiye",
    "abbreviation": "TR",
    "regionId": "203",
    "siteId": "174",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "Republic of Korea",
    "abbreviation": "KR",
    "regionId": "185",
    "siteId": "119",
    "dataDeploymentArea": "GLOBAL",
    "availableForSemiSellers": "",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "Portugal",
    "abbreviation": "PT",
    "regionId": "163",
    "siteId": "111",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "Japan",
    "abbreviation": "JP",
    "regionId": "100",
    "siteId": "118",
    "dataDeploymentArea": "GLOBAL",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "Hungary",
    "abbreviation": "HU",
    "regionId": "90",
    "siteId": "138",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "Czech Republic",
    "abbreviation": "CZ",
    "regionId": "53",
    "siteId": "137",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "Australia",
    "abbreviation": "AU",
    "regionId": "12",
    "siteId": "103",
    "dataDeploymentArea": "GLOBAL",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "United States",
    "abbreviation": "US",
    "regionId": "211",
    "siteId": "100",
    "dataDeploymentArea": "US",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "Germany",
    "abbreviation": "DE",
    "regionId": "76",
    "siteId": "105",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "France",
    "abbreviation": "FR",
    "regionId": "69",
    "siteId": "106",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "Italy",
    "abbreviation": "IT",
    "regionId": "98",
    "siteId": "107",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "Spain",
    "abbreviation": "ES",
    "regionId": "186",
    "siteId": "109",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "United Kingdom",
    "abbreviation": "UK",
    "regionId": "210",
    "siteId": "102",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "Belgium",
    "abbreviation": "BE",
    "regionId": "20",
    "siteId": "142",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "Netherlands",
    "abbreviation": "NL",
    "regionId": "141",
    "siteId": "108",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "Poland",
    "abbreviation": "PL",
    "regionId": "162",
    "siteId": "112",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "Mexico",
    "abbreviation": "MX",
    "regionId": "128",
    "siteId": "110",
    "dataDeploymentArea": "GLOBAL",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "Austria",
    "abbreviation": "AT",
    "regionId": "13",
    "siteId": "143",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "Canada",
    "abbreviation": "CA",
    "regionId": "37",
    "siteId": "101",
    "dataDeploymentArea": "GLOBAL",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "Romania",
    "abbreviation": "RO",
    "regionId": "167",
    "siteId": "140",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "Denmark",
    "abbreviation": "DK",
    "regionId": "54",
    "siteId": "139",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "Sweden",
    "abbreviation": "SE",
    "regionId": "191",
    "siteId": "113",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "Greece",
    "abbreviation": "GR",
    "regionId": "79",
    "siteId": "115",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "Slovakia",
    "abbreviation": "SK",
    "regionId": "180",
    "siteId": "145",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "Finland",
    "abbreviation": "FI",
    "regionId": "68",
    "siteId": "144",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "Bulgaria",
    "abbreviation": "BG",
    "regionId": "32",
    "siteId": "141",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "Slovenia",
    "abbreviation": "SI",
    "regionId": "181",
    "siteId": "147",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": "true"
  },
  {
    "fullName": "New Zealand",
    "abbreviation": "NZ",
    "regionId": "144",
    "siteId": "104",
    "dataDeploymentArea": "GLOBAL",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Saudi Arabia",
    "abbreviation": "SA",
    "regionId": "174",
    "siteId": "120",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Colombia",
    "abbreviation": "CO",
    "regionId": "45",
    "siteId": "164",
    "dataDeploymentArea": "GLOBAL",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Philippines",
    "abbreviation": "PH",
    "regionId": "160",
    "siteId": "127",
    "dataDeploymentArea": "GLOBAL",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Croatia",
    "abbreviation": "HR",
    "regionId": "50",
    "siteId": "146",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Lithuania",
    "abbreviation": "LT",
    "regionId": "113",
    "siteId": "148",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Malta",
    "abbreviation": "MT",
    "regionId": "122",
    "siteId": "151",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Cyprus",
    "abbreviation": "CY",
    "regionId": "52",
    "siteId": "117",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Luxembourg",
    "abbreviation": "LU",
    "regionId": "114",
    "siteId": "152",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "South Africa",
    "abbreviation": "ZA",
    "regionId": "184",
    "siteId": "136",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Norway",
    "abbreviation": "NO",
    "regionId": "151",
    "siteId": "124",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Chile",
    "abbreviation": "CL",
    "regionId": "42",
    "siteId": "125",
    "dataDeploymentArea": "GLOBAL",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Israel",
    "abbreviation": "IL",
    "regionId": "97",
    "siteId": "135",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Ecuador",
    "abbreviation": "EC",
    "regionId": "59",
    "siteId": "178",
    "dataDeploymentArea": "GLOBAL",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Georgia",
    "abbreviation": "GE",
    "regionId": "75",
    "siteId": "165",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Peru",
    "abbreviation": "PE",
    "regionId": "159",
    "siteId": "163",
    "dataDeploymentArea": "GLOBAL",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Kuwait",
    "abbreviation": "KW",
    "regionId": "105",
    "siteId": "123",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Qatar",
    "abbreviation": "QA",
    "regionId": "165",
    "siteId": "130",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Moldova",
    "abbreviation": "MD",
    "regionId": "130",
    "siteId": "154",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Azerbaijan",
    "abbreviation": "AZ",
    "regionId": "14",
    "siteId": "167",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Serbia",
    "abbreviation": "RS",
    "regionId": "175",
    "siteId": "153",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Malaysia",
    "abbreviation": "MY",
    "regionId": "119",
    "siteId": "126",
    "dataDeploymentArea": "GLOBAL",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Oman",
    "abbreviation": "OM",
    "regionId": "152",
    "siteId": "133",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Thailand",
    "abbreviation": "TH",
    "regionId": "197",
    "siteId": "129",
    "dataDeploymentArea": "GLOBAL",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Bahrain",
    "abbreviation": "BH",
    "regionId": "16",
    "siteId": "134",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Armenia",
    "abbreviation": "AM",
    "regionId": "10",
    "siteId": "166",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Morocco",
    "abbreviation": "MA",
    "regionId": "135",
    "siteId": "171",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "true",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Afghanistan",
    "abbreviation": "AF",
    "regionId": "2",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Albania",
    "abbreviation": "AL",
    "regionId": "3",
    "siteId": "159",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Algeria",
    "abbreviation": "DZ",
    "regionId": "4",
    "siteId": "175",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Andorra",
    "abbreviation": "AD",
    "regionId": "5",
    "siteId": "157",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Angola",
    "abbreviation": "AO",
    "regionId": "6",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Anguilla",
    "abbreviation": "AI",
    "regionId": "7",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Antigua and Barbuda",
    "abbreviation": "AG",
    "regionId": "8",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Argentina",
    "abbreviation": "AR",
    "regionId": "9",
    "siteId": "189",
    "dataDeploymentArea": "GLOBAL",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Aruba",
    "abbreviation": "AW",
    "regionId": "11",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Bahamas",
    "abbreviation": "BS",
    "regionId": "15",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Bangladesh",
    "abbreviation": "BD",
    "regionId": "17",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Barbados",
    "abbreviation": "BB",
    "regionId": "18",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Belarus",
    "abbreviation": "BY",
    "regionId": "19",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Belize",
    "abbreviation": "BZ",
    "regionId": "21",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Benin",
    "abbreviation": "BJ",
    "regionId": "22",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Bermuda",
    "abbreviation": "BM",
    "regionId": "23",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Bhutan",
    "abbreviation": "BT",
    "regionId": "24",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Bolivia",
    "abbreviation": "BO",
    "regionId": "25",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Bosnia and Herzegovina",
    "abbreviation": "BA",
    "regionId": "26",
    "siteId": "158",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Botswana",
    "abbreviation": "BW",
    "regionId": "27",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Bouvet Island",
    "abbreviation": "BV",
    "regionId": "28",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "British Indian Ocean Territory",
    "abbreviation": "IO",
    "regionId": "30",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Burkina Faso",
    "abbreviation": "BF",
    "regionId": "33",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Burundi",
    "abbreviation": "BI",
    "regionId": "34",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Cambodia",
    "abbreviation": "KH",
    "regionId": "35",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Cameroon",
    "abbreviation": "CM",
    "regionId": "36",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Cape Verde",
    "abbreviation": "CV",
    "regionId": "38",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Cayman Islands",
    "abbreviation": "KY",
    "regionId": "39",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Central African Republic",
    "abbreviation": "CF",
    "regionId": "40",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Chad",
    "abbreviation": "TD",
    "regionId": "41",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "China",
    "abbreviation": "CN",
    "regionId": "43",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Christmas Island",
    "abbreviation": "CX",
    "regionId": "44",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Comoros",
    "abbreviation": "KM",
    "regionId": "46",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Congo",
    "abbreviation": "CG",
    "regionId": "47",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Cook Islands",
    "abbreviation": "CK",
    "regionId": "48",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Costa Rica",
    "abbreviation": "CR",
    "regionId": "49",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Cuba",
    "abbreviation": "CU",
    "regionId": "51",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Djibouti",
    "abbreviation": "DJ",
    "regionId": "55",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Dominica",
    "abbreviation": "DM",
    "regionId": "56",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Dominican Republic",
    "abbreviation": "DO",
    "regionId": "57",
    "siteId": "172",
    "dataDeploymentArea": "GLOBAL",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "East Timor",
    "abbreviation": "TL",
    "regionId": "58",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Egypt",
    "abbreviation": "EG",
    "regionId": "60",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "El Salvador",
    "abbreviation": "SV",
    "regionId": "61",
    "siteId": "183",
    "dataDeploymentArea": "GLOBAL",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Equatorial Guinea",
    "abbreviation": "GQ",
    "regionId": "62",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Eritrea",
    "abbreviation": "ER",
    "regionId": "63",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Ethiopia",
    "abbreviation": "ET",
    "regionId": "65",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Faroe Islands",
    "abbreviation": "FO",
    "regionId": "66",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Fiji",
    "abbreviation": "FJ",
    "regionId": "67",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "French Guiana",
    "abbreviation": "GF",
    "regionId": "70",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "French Polynesia",
    "abbreviation": "PF",
    "regionId": "71",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "French Southern Territories",
    "abbreviation": "TF",
    "regionId": "72",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Gabon",
    "abbreviation": "GA",
    "regionId": "73",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Gambia",
    "abbreviation": "GM",
    "regionId": "74",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Ghana",
    "abbreviation": "GH",
    "regionId": "77",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Gibraltar",
    "abbreviation": "GI",
    "regionId": "78",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Greenland",
    "abbreviation": "GL",
    "regionId": "80",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Grenada",
    "abbreviation": "GD",
    "regionId": "81",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Guadeloupe",
    "abbreviation": "GP",
    "regionId": "82",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Guam",
    "abbreviation": "GU",
    "regionId": "83",
    "siteId": "100",
    "dataDeploymentArea": "US",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Guatemala",
    "abbreviation": "GT",
    "regionId": "84",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Guinea",
    "abbreviation": "GN",
    "regionId": "85",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Guinea-Bissau",
    "abbreviation": "GW",
    "regionId": "86",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Guyana",
    "abbreviation": "GY",
    "regionId": "87",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Haiti",
    "abbreviation": "HT",
    "regionId": "88",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Holy See",
    "abbreviation": "VA",
    "regionId": "215",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Honduras",
    "abbreviation": "HN",
    "regionId": "89",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "India",
    "abbreviation": "IN",
    "regionId": "92",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Indonesia",
    "abbreviation": "ID",
    "regionId": "93",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Iran",
    "abbreviation": "IR",
    "regionId": "94",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Iraq",
    "abbreviation": "IQ",
    "regionId": "95",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Jamaica",
    "abbreviation": "JM",
    "regionId": "99",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Kazakhstan",
    "abbreviation": "KZ",
    "regionId": "102",
    "siteId": "162",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Kenya",
    "abbreviation": "KE",
    "regionId": "103",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Kiribati",
    "abbreviation": "KI",
    "regionId": "104",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Lao People's Democratic Republic",
    "abbreviation": "LA",
    "regionId": "107",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Lebanon",
    "abbreviation": "LB",
    "regionId": "109",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Lesotho",
    "abbreviation": "LS",
    "regionId": "110",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Liberia",
    "abbreviation": "LR",
    "regionId": "111",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Liechtenstein",
    "abbreviation": "LI",
    "regionId": "112",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Macao",
    "abbreviation": "MO",
    "regionId": "115",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Madagascar",
    "abbreviation": "MG",
    "regionId": "117",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Malawi",
    "abbreviation": "MW",
    "regionId": "118",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Maldives",
    "abbreviation": "MV",
    "regionId": "120",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Mali",
    "abbreviation": "ML",
    "regionId": "121",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Marshall Islands",
    "abbreviation": "MH",
    "regionId": "123",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Martinique",
    "abbreviation": "MQ",
    "regionId": "124",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Mauritania",
    "abbreviation": "MR",
    "regionId": "125",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Mayotte",
    "abbreviation": "YT",
    "regionId": "127",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Micronesia",
    "abbreviation": "FM",
    "regionId": "129",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Monaco",
    "abbreviation": "MC",
    "regionId": "131",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Mongolia",
    "abbreviation": "MN",
    "regionId": "132",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Montserrat",
    "abbreviation": "MS",
    "regionId": "133",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Mozambique",
    "abbreviation": "MZ",
    "regionId": "136",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Myanmar",
    "abbreviation": "MM",
    "regionId": "137",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Namibia",
    "abbreviation": "NA",
    "regionId": "138",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Nauru",
    "abbreviation": "NR",
    "regionId": "139",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Nepal",
    "abbreviation": "NP",
    "regionId": "140",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Netherlands Antilles",
    "abbreviation": "AN",
    "regionId": "142",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "New Caledonia",
    "abbreviation": "NC",
    "regionId": "143",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Nicaragua",
    "abbreviation": "NI",
    "regionId": "145",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Niger",
    "abbreviation": "NE",
    "regionId": "146",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Nigeria",
    "abbreviation": "NG",
    "regionId": "147",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Niue",
    "abbreviation": "NU",
    "regionId": "148",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Norfolk Island",
    "abbreviation": "NF",
    "regionId": "149",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "North Korea",
    "abbreviation": "KP",
    "regionId": "150",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Pakistan",
    "abbreviation": "PK",
    "regionId": "153",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Palau",
    "abbreviation": "PW",
    "regionId": "154",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Palestine",
    "abbreviation": "PS",
    "regionId": "155",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Papua New Guinea",
    "abbreviation": "PG",
    "regionId": "157",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Paraguay",
    "abbreviation": "PY",
    "regionId": "158",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Pitcairn",
    "abbreviation": "PN",
    "regionId": "161",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Puerto Rico",
    "abbreviation": "PR",
    "regionId": "164",
    "siteId": "100",
    "dataDeploymentArea": "US",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Reunion",
    "abbreviation": "RE",
    "regionId": "166",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Russian Federation",
    "abbreviation": "RU",
    "regionId": "168",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Rwanda",
    "abbreviation": "RW",
    "regionId": "169",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Saint Lucia",
    "abbreviation": "LC",
    "regionId": "170",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Samoa",
    "abbreviation": "WS",
    "regionId": "171",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "San Marino",
    "abbreviation": "SM",
    "regionId": "172",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Sao Tome and Principe",
    "abbreviation": "ST",
    "regionId": "173",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Senegal",
    "abbreviation": "SN",
    "regionId": "176",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Seychelles",
    "abbreviation": "SC",
    "regionId": "177",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Sierra Leone",
    "abbreviation": "SL",
    "regionId": "178",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Singapore",
    "abbreviation": "SG",
    "regionId": "179",
    "siteId": "121",
    "dataDeploymentArea": "GLOBAL",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Solomon Islands",
    "abbreviation": "SB",
    "regionId": "182",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Somalia",
    "abbreviation": "SO",
    "regionId": "183",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Sudan",
    "abbreviation": "SD",
    "regionId": "188",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Suriname",
    "abbreviation": "SR",
    "regionId": "189",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Swaziland",
    "abbreviation": "SZ",
    "regionId": "190",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Syrian Arab Republic",
    "abbreviation": "SY",
    "regionId": "193",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Taiwan, China",
    "abbreviation": "TW",
    "regionId": "194",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Tajikistan",
    "abbreviation": "TJ",
    "regionId": "195",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Tanzania",
    "abbreviation": "TZ",
    "regionId": "196",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Togo",
    "abbreviation": "TG",
    "regionId": "198",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Tokelau",
    "abbreviation": "TK",
    "regionId": "199",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Tonga",
    "abbreviation": "TO",
    "regionId": "200",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Trinidad and Tobago",
    "abbreviation": "TT",
    "regionId": "201",
    "siteId": "179",
    "dataDeploymentArea": "GLOBAL",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Tunisia",
    "abbreviation": "TN",
    "regionId": "202",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Turkmenistan",
    "abbreviation": "TM",
    "regionId": "204",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Turks and Caicos Islands",
    "abbreviation": "TC",
    "regionId": "205",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Tuvalu",
    "abbreviation": "TV",
    "regionId": "206",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Uganda",
    "abbreviation": "UG",
    "regionId": "207",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Ukraine",
    "abbreviation": "UA",
    "regionId": "208",
    "siteId": "168",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Uruguay",
    "abbreviation": "UY",
    "regionId": "212",
    "siteId": "169",
    "dataDeploymentArea": "GLOBAL",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Uzbekistan",
    "abbreviation": "UZ",
    "regionId": "213",
    "siteId": "181",
    "dataDeploymentArea": "EU",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Vanuatu",
    "abbreviation": "VU",
    "regionId": "214",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Venezuela",
    "abbreviation": "VE",
    "regionId": "216",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Vietnam",
    "abbreviation": "VN",
    "regionId": "217",
    "siteId": "187",
    "dataDeploymentArea": "GLOBAL",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Virgin Islands (British)",
    "abbreviation": "VG",
    "regionId": "218",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Virgin Islands (U.S.)",
    "abbreviation": "VI",
    "regionId": "219",
    "siteId": "100",
    "dataDeploymentArea": "US",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Wallis and Futuna",
    "abbreviation": "WF",
    "regionId": "220",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Western Sahara",
    "abbreviation": "EH",
    "regionId": "221",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Yemen",
    "abbreviation": "YE",
    "regionId": "222",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Yugoslavia",
    "abbreviation": "YU",
    "regionId": "223",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Zambia",
    "abbreviation": "ZM",
    "regionId": "224",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Zimbabwe",
    "abbreviation": "ZW",
    "regionId": "225",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Hong Kong",
    "abbreviation": "HK",
    "regionId": "226",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Saint Kitts and Nevis",
    "abbreviation": "KN",
    "regionId": "227",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Saint Vincent and the Grenadines",
    "abbreviation": "VC",
    "regionId": "228",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Ivory Coast",
    "abbreviation": "CI",
    "regionId": "229",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Democratic Republic of the Congo",
    "abbreviation": "CD",
    "regionId": "230",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Saint Pierre and Miquelon",
    "abbreviation": "PM",
    "regionId": "231",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Svalbard and Jan Mayen",
    "abbreviation": "SJ",
    "regionId": "232",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Saint Helena, Ascension and Tristan da Cunha",
    "abbreviation": "SH",
    "regionId": "233",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Falkland Islands",
    "abbreviation": "FK",
    "regionId": "234",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Kosovo",
    "abbreviation": "XK",
    "regionId": "235",
    "siteId": "",
    "dataDeploymentArea": "",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  },
  {
    "fullName": "Northern Mariana Islands",
    "abbreviation": "MP",
    "regionId": "236",
    "siteId": "100",
    "dataDeploymentArea": "US",
    "availableForSemiSellers": "",
    "availableForLocalSellers": ""
  }
];

export const regionsAndSitesData_byCountryCode = regionsAndSitesData.reduce<{
  [key: string]: typeof regionsAndSitesData[number];
}>((acc, curr) => {
  acc[curr.abbreviation] = curr;
  return acc;
}, {});

export const regionsAndSitesData_bySiteId = regionsAndSitesData.reduce<{
  [key: string]: typeof regionsAndSitesData[number];
}>((acc, curr) => {
  acc[String(curr.siteId)] = curr;
  return acc;
}, {});